import styles from "./GoogleMark.module.css";

/**
 * Google's sign-in mark, drawn inline.
 *
 * Inline because canon `docs/SECURITY.md` keeps this private seller surface free of
 * third-party requests — a hosted image or an icon font would tell Google that a specific
 * browser was sitting on Dealbid's sign-in page before anyone had chosen to sign in.
 * `test/security/source.test.ts` holds that line.
 *
 * The mark sits on a fixed white chip rather than on the button's own colour. Its four
 * brand colours are not ours to re-tint for a dark theme, and a mark that shifted with the
 * theme would stop being the recognisable thing a founder is looking for. The chip keeps it
 * on the background it was drawn for in both themes.
 *
 * Decorative: the control's own text says "Continue with Google", so announcing the mark
 * again would read the same word twice.
 */
export function GoogleMark() {
  return (
    <span className={styles.chip} aria-hidden="true">
      <svg viewBox="0 0 18 18" focusable="false" className={styles.mark}>
        <path
          fill="#4285F4"
          d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62Z"
        />
        <path
          fill="#34A853"
          d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z"
        />
        <path
          fill="#FBBC05"
          d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z"
        />
        <path
          fill="#EA4335"
          d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z"
        />
      </svg>
    </span>
  );
}
